module.exports = __webpack_public_path__ + "static/media/floor_floating_compact.61c9fb0a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_floating_compact.png
 ** module id = 953
 ** module chunks = 0
 **/